import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../services/authAPI";
import Field from "../components/Field";

export default function VehiclesPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;
    const [vehicles, setVehicles] = useState([]);
    const [brands, setBrands] = useState([]);

    async function fetchVehicles() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicles`);
            const data = await response.json();
            setVehicles(data);
        } catch {
            // silently handled
        }
    }

    async function fetchBrands() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicle_brands`);
            const data = await response.json();
            setBrands(data);
        } catch {
            // silently handled
        }
    }

    useEffect(() => {
        fetchVehicles();
        fetchBrands();
    }, []);

    const filteredVehicles = vehicles.filter(
        (vehicle) =>
            vehicle.licensePlateNumber?.toLowerCase().includes(search.toLowerCase()) ||
            vehicle.name?.toLowerCase().includes(search.toLowerCase()) ||
            vehicle.brand?.toLowerCase().includes(search.toLowerCase()) ||
            vehicle.model?.toLowerCase().includes(search.toLowerCase()),
    );

    const totalPages = Math.ceil(filteredVehicles.length / entriesPerPage);

    const paginatedVehicles = filteredVehicles.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage,
    );

    const BRAND_LABELS = Object.fromEntries(
        brands.map((b) =>
            [b.value, b.label]
        )
    );

    return (
        <>
            <section>
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <Field
                                    name="search"
                                    label="Rechercher un véhicule..."
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    type="text"
                                    margin={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                    {paginatedVehicles.map((vehicle) => (
                        <div
                            key={vehicle.id}
                            className="card mb-3 border-0 shadow-sm rounded-4"
                            onClick={() => navigate(`/vehicles/${vehicle.id}`)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="card-body d-flex align-items-center justify-content-between px-4 py-3">
                                <div className={!vehicle.name ? "d-flex align-items-center" : ""}>
                                    <h6 className="fw-bold">
                                        {vehicle.name && (
                                        <span className="text-muted">{vehicle.name} ┃ </span>
                                    )}{BRAND_LABELS[vehicle.brand] ?? vehicle.brand} {vehicle.model}
                                    </h6>
                                </div>
                                <span
                                    className="badge rounded-3 px-3 py-2 fs-6 fw-semibold badge-secondary"
                                >
                                    {vehicle.licensePlateNumber}
                                </span>
                            </div>
                        </div>
                    ))}

                    {totalPages > 1 && (
                        <nav className="d-flex justify-content-end mt-4">
                            <ul className="pagination pagination-sm mb-0">
                                <li
                                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage((p) => p - 1)}
                                    >
                                        <i className="fas fa-chevron-left fa-xs"></i>
                                    </button>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li
                                        key={i}
                                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(i + 1)}
                                        >
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}
                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage((p) => p + 1)}
                                    >
                                        <i className="fas fa-chevron-right fa-xs"></i>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
            </section>
        </>
    );
}
